<div class="app-container">
	<div class="app-status-page-container">
		<i class="fa-jelly fa-regular fa-lock fa-beat text-7xl text-[#f79f00]"></i>
		<h1 class="mt-6 mb-2 text-xl font-semibold">Access to this page is restricted</h1>
		<p>We are sorry, but you do not have access to this page or resource</p>
	</div>
</div>
